import React, { useEffect } from "react";
import "./Snow.scss";
import { memo } from "react";

function Snow() {
  useEffect(() => {
    const canvas = document.getElementById("canvas");
    const element = document.getElementById("id-now-container");

    if (!canvas || !element) return;

    let animationId = null;
    let resizeTimer = null;

    function startAnimation() {
      if (animationId) cancelAnimationFrame(animationId);

      const height = element.offsetHeight;
      canvas.style.height = height + "px";

      const CANVAS_WIDTH = element.offsetWidth;
      const CANVAS_HEIGHT = height;

      const ctx = canvas.getContext("2d");
      canvas.width = CANVAS_WIDTH;
      canvas.height = CANVAS_HEIGHT;

      function random(f = 1) {
        return Math.random() * f;
      }

      const total = window.innerWidth < 768 ? 120 : 250;

      class Circle {
        constructor() {
          this.reset();
        }

        reset() {
          this.radius = random(window.innerWidth < 768 ? 1.5 : 2.2);
          this.x = random(CANVAS_WIDTH);
          this.y = random(CANVAS_HEIGHT);
          this.vx = (Math.random() - 0.5) * 0.3;
          this.vy = 0.4 + this.radius * 0.25;
        }

        update() {
          this.x += this.vx;
          this.y += this.vy;

          if (this.y > CANVAS_HEIGHT || this.x < 0 || this.x > CANVAS_WIDTH) {
            this.reset();
            this.y = 0;
          }
        }

        draw() {
          ctx.moveTo(this.x, this.y);
          ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        }
      }

      const circles = Array.from({ length: total }, () => new Circle());

      let lastTime = 0;
      const fpsInterval = 1000 / 30; // 30fps

      function animate(timestamp) {
        animationId = requestAnimationFrame(animate);

        if (timestamp - lastTime < fpsInterval) return;
        lastTime = timestamp;

        ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

        ctx.beginPath();
        circles.forEach((c) => {
          c.update();
          c.draw();
        });
        ctx.fillStyle = "rgba(255,255,255,0.5)";
        ctx.fill();
      }

      animate();
    }

    // Run animation
    startAnimation();

    // Debounce resize
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(startAnimation, 300);
    });

    return () => {
      if (animationId) cancelAnimationFrame(animationId);
      window.removeEventListener("resize", startAnimation);
    };
  }, []);

  return (
    <div id="id-now-container">
      <canvas id="canvas"></canvas>
    </div>
  );
}

export default memo(Snow);
